import { Grid } from '@mui/material';
import NoGraphData from './NoGraphData';
import AgrochemicalsFacilityBarGraph from './AgrochemicalsFacilityBarGraph';
import AgrochemicalsFacilityPieChart from './AgrochemicalsFacilityPieChart';

export default function AgrochemicalsGraphPairForFacilities({ barGraphData, pieChartData, groupName, year, type, unit }) {
    const EXCLUDED_GROUP_NAME = 'Vinimark Trading'
    return (
        <NoGraphData data={barGraphData} year={year} type={type} variant={'agrochemicals'}>
            {groupName !== EXCLUDED_GROUP_NAME &&
                <>
                    <Grid xs={12} xl={6} item display="flex" alignContent={'space-between'} mb={'3rem'}>
                        <AgrochemicalsFacilityBarGraph data={barGraphData} group={groupName} type={type} year={year} unit={unit} />
                    </Grid>
                    <Grid xs={12} xl={6} item display="flex" alignContent={'space-between'} mb={'3rem'}>
                        <AgrochemicalsFacilityPieChart data={pieChartData} group={groupName} type={type} year={year} unit={unit} />
                    </Grid>
                </>
            }
        </NoGraphData>
    )
}